export const hasPermission = (roles: string[], authorities?: string[]): boolean => {
  if (!authorities) return false;
  if (roles.length === 0) return true;
  return !!roles.find((role) => {
    return authorities.find((authority) => role === authority);
  });
};
